export default {"src":"/_next/static/media/webinar-polygon.e61e6ff0.svg","height":309,"width":354,"blurWidth":0,"blurHeight":0};